// extracted by mini-css-extract-plugin
module.exports = {"root":"VBtxD","radioButton":"L6y4F","footer":"ARSVT","button":"_2l52n"};